import React, { useState, useEffect, useContext } from "react";
import ConfigComponent from "../ConfigComponent";
import { StateContext } from "../../state";
import classnames from "classnames";
import { logger } from "../../utils/logging";
import { LOGGING } from "../../utils/enums";
import { useTranslation } from "react-i18next";
import { useLoggerOnMountEvents } from "../../utils/hooks";
import { get } from "lodash/object";

export const Faq = () => {
  const [applicationState] = useContext(StateContext);
  const [activeItemIndex, setActiveItemIndex] = useState(null);
  const faqs = get(applicationState, "configuration.faqs", []);
  const programName = get(applicationState, "configuration.programName", "");
  const faqEntityName = get(applicationState, "configuration.faqEntityName", "");
  const programId = get(applicationState, "payment.programId");
  const [t, i18n] = useTranslation(); // eslint-disable-line no-unused-vars

  useLoggerOnMountEvents(
    LOGGING.EVENTS.FAQS_OPENED,
    LOGGING.EVENTS.FAQS_CLOSED
  );

  useEffect(() => {
    const faqItemIsBeingViewed = Number.isInteger(activeItemIndex);
    if (faqItemIsBeingViewed) {
      logger({
        event: LOGGING.EVENTS.FAQ_ITEM_EXPANDED,
        faq: faqs[activeItemIndex].question,
        language: i18n.language,
        programName: programName,
        programId: programId
      });
    }
  }, [activeItemIndex]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="faq-section">
      {faqs.map((item, itemIdx) => (
        <div
          className={classnames("faq-item", {
            active: itemIdx === activeItemIndex
          })}
          key={itemIdx}
          onClick={evt =>
            setActiveItemIndex(activeItemIndex === itemIdx ? null : itemIdx)
          }
        >
          <div className="faq-trigger">
            <div className="faq-question">
              <h3>
                <ConfigComponent
                  config={item.question}
                  data={{ programName }}
                />
              </h3>
            </div>
            <span
              className={`faq-trigger-caret${
                activeItemIndex === itemIdx ? " faq-trigger-caret--active" : ""
              }`}
            >
              &rsaquo;
            </span>
          </div>
          <div
            className={`faq-answer${
              activeItemIndex === itemIdx ? " faq-answer--active" : ""
            }`}
          >
            <ConfigComponent
              config={item.answer}
              data={{ programName: faqEntityName || programName }}
            />
          </div>
        </div>
      ))}
    </div>
  );
};

export default Faq;
